export const SecuritySection = () => {
  return (
    <section className="border-y border-slate-200 bg-white py-14">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <h2 className="text-2xl font-bold text-slate-900">Segurança e LGPD</h2>
        <ul className="mt-5 grid gap-3 text-sm text-slate-600 sm:grid-cols-2">
          <li>Certificados e PII cifrados em repouso</li>
          <li>Auditoria imutável com HMAC por linha</li>
          <li>Logs sem segredos; retenção fiscal de 5 anos</li>
          <li>
            Detalhes em{" "}
            <a href="/privacidade" className="font-medium text-brand-600 hover:underline">
              privacidade
            </a>{" "}
            e{" "}
            <a href="/termos" className="font-medium text-brand-600 hover:underline">
              termos
            </a>
          </li>
        </ul>
      </div>
    </section>
  )
}
